export default {
    theme: {
        colors: {
            'rothcoBlack': '#000000',
            'rothcoCharcoal': '#1c1d1f',
            'rothcoText': '#e8c33a',
            'rothcoRed': '#aa1e2d',
            'rothcoRover': '#6f252d',
            'rothcoSolar': '#eebd2b',
            'rothcoWhite': '#ffffff',
            'rothcoForest': '#303e1f',
            'rothcoCombat': '#595b3e',
            'rothcoRanger': '#7f8065',
            'rothcoVoyage': '#19252e',
            'rothcoTrailblazer': '#9b6839',
            'rothcoCoyote': '#c2a788',
            'rothcoTumbleweed': '#ded4c3',
            'rothcoCloud': '#ebe9e3',
            'rothcoCream': '#f3f3f1',
            'rothcoLightOrange': '#ffd1a8',
            'alto': '#D9D9D9',
            'gallery': '#EDEDED',
            'thunder': '#231F20',
            'silverChalice': '#AEAEAE',
            'tundora': '#4D4D4D',
            'shark': '#292A2F',
            'sepiaSkin' : '#9B6839',
            'silver': '#CCCCCC'
        },
        fontFamily: {
            'refrigerator': ['"refrigerator-deluxe"'],
            'sans': ['"work-sans"'],
            'roboto': ['"roboto-mono"']
        },
        fontSize: {
            'base': 'clamp(14px,1.11vw,16px)',
            'lg': 'clamp(32px,3.05vw,44px)',
            'xl': 'clamp(36px,4.72vw,68px)',
        },
        breakpoints: {
            'breakpoint-mobile-xs': 360,
            /* custom breakpoint for color swatches*/
            'breakpoint-mobile-sm': 456,
            'breakpoint-tablet': 760,
            'breakpoint-desktop': 990,
            // custom breakpoint for plp grid with filters open
            'breakpoint-small-desktop': 1280,
            'breakpoint-5th-image-desktop': 1390,
            'breakpoint-desktop-md': 1280,
            'breakpoint-desktop-xl': 1440,
            'breakpoint-desktop-xxl': 1920,
        }
    }
}